import React from 'react';
import {Button, Card, Form, Icon, message, Select, Spin, Switch, Tooltip} from 'antd';
import CkInfoItem from "../../components/CkInfoItem";
import {fetchEvt} from "../../redux/actions/evt";
import {findRollpools} from "../../services/luckydraw";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {inEditMode} from "../../redux/actions/global";
import {patchEventConfig} from "../../services/evt";
import PurchaseServiceTips from "../PurchaseServiceTips";
import {isValidity} from "../../services/global";



const mapStateToPorps = state => {
    const loginedUser = state.loginedUser;
    const cmEnums = state.cmEnums;
    return {cmEnums, loginedUser};
};
const mapDispatchToProps = dispatch => ({
    fetchEvt: bindActionCreators(fetchEvt, dispatch),
});


class EvtViewOrganizerCheckinAction extends React.Component {
    constructor(props) {
        super(props);
        this.pstView = null;
        console.log(props)
        this.state = {
            validity: false,
            formLoading: false,
            allowAutoRoll: props.evt.config.allowAutoRoll,
            roll: []

        }
    }

    componentDidMount() {
        findRollpools({eventId: this.props.evt.header.id}).then(res => {
            if (res.code == 200) {
                this.setState({
                    roll: res.data
                })

            } else {
                message.error(res.msg,6);
            }
        }).catch(err => {
            message.warn("访问异常");
        })


        isValidity('SENIORMEMBER', (vaild) => {
            this.setState({
                validity: vaild
            })
        })

    }

    intoEdit = () => {
        this.props.editableChange(this.props.editableStatePropName, true)
    }
    cancelEdit = () => {
        this.props.editableChange(this.props.editableStatePropName, false)
    }

    save = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {
            if (!error) {
                this.changeFormLoading(true)
                console.log(values)
                patchEventConfig(Object.assign({id: this.props.evt.header.id}, values)).then(res => {
                    console.log("updateEventConfig res: ", res);
                    if (res.code == 200) {
                        message.info("更新成功!");
                        this.props.editableChange(this.props.editableStatePropName, false, true)
                    } else {
                        message.error(res.msg,6);
                    }
                }).catch(err => {
                    message.warn("访问异常");
                }).finally(() => {
                    this.changeFormLoading(false)
                })
            } else {
                console.log('error', error, values);
            }
        });
    }

    changeFormLoading = (loading) => {
        this.setState({
            formLoading: loading
        })
    }

    render() {
        const evt = this.props.evt;
        const {getFieldDecorator, getFieldValue, getFieldsValue, getFieldError, setFieldsValue} = this.props.form;

        const editableTools = this.props.editable ?
            <div className="evt-create-editable-tools">
                <Button type="primary" size="small" onClick={this.save}>保存</Button>
                <Button type="primary" size="small" ghost onClick={this.cancelEdit}>放弃</Button>
            </div>
            :
            <div className="evt-create-editable-tools" onClick={() => {
                this.intoEdit()
                // this.state.validity ? this.intoEdit() : this.pstView.show()
            }}>
                <Button type="primary" size="small" ghost>编辑</Button>
            </div>

        return (
            <Form>
                <Spin spinning={this.state.formLoading}>
                    <Card bodyStyle={{padding: "16px"}}>
                        {editableTools}

                        <CkInfoItem
                            label={<span>签到后自动大屏摇奖&nbsp;

                                        <Tooltip placement="bottom" overlayClassName='overlay-image'
                                                 mouseEnterDelay={0.3} title={
                                            <div>
                                                人脸识别或主办方扫码枪签到后，自动给当前签到人摇奖，可以大屏投影结果，适合签到后随机发送奖品的场景
                                            </div>
                                        }>
                                                    <Icon type="question-circle-o"/>
                                            </Tooltip>
                                    </span>}
                        >
                            {
                                this.props.editable ?
                                    <div style={{width: '50%',}}>
                                        {getFieldDecorator(`allowAutoRoll`, {
                                            initialValue: evt.config.allowAutoRoll,
                                            valuePropName: 'checked',
                                            rules: [{required: false}],
                                        })(
                                            <Switch checkedChildren={"开启"} unCheckedChildren={"关闭"}
                                                    onChange={e => this.setState({allowAutoRoll: e})}/>
                                        )}
                                    </div>
                                    :
                                    evt.config.allowAutoRoll ? '已开启' : "未开启"
                            }
                        </CkInfoItem>

                        {this.props.editable && this.state.allowAutoRoll &&
                        <CkInfoItem label={'指定奖池'}>

                            <div style={{width: '50%'}}>
                                {getFieldDecorator('autoRollPoolId', {
                                    initialValue: evt.config.autoRollPoolId == 0 ? null : evt.config.autoRollPoolId,
                                    rules: [
                                        {required: true, message: '请选择!', whitespace: true},
                                    ],
                                })(
                                    <Select
                                        placeholder="请选择奖池"
                                    >
                                        {
                                            this.state.roll.map((item, index) => {
                                                return <Select.Option value={item.id}
                                                                      key={index}>
                                                    {item.poolName}
                                                </Select.Option>
                                            })
                                        }
                                    </Select>
                                )}
                            </div>
                        </CkInfoItem>}

                    </Card>
                </Spin>
                <PurchaseServiceTips
                    ref={(pst) => {
                        this.pstView = pst
                    }}
                    member={'SENIORMEMBER'}
                />
            </Form>
        )
    }
}


EvtViewOrganizerCheckinAction.contextTypes = {}

EvtViewOrganizerCheckinAction.defaultProps = {
    evt: {},
    editable: false,
    editableStatePropName: "organizerCheckinAction",
    editableChange: (editable, dataChanged = false) => null,
}

EvtViewOrganizerCheckinAction.propTypes = {}


export default connect(mapStateToPorps, mapDispatchToProps)(Form.create()(EvtViewOrganizerCheckinAction));


// WEBPACK FOOTER //
// ./src/containers/evt/EvtViewOrganizerCheckinAction.jsx